import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

export default function TestTypeCreate() {
  const [title, setTitle] = useState("");
  const [minAge, setMinAge] = useState("");
  const [maxAge, setMaxAge] = useState("");
  const [loading, setLoading] = useState(false);

  const nav = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!title.trim()) {
      return toast.error("Başlık zorunlu!");
    }

    setLoading(true);
    try {
      await axios.post(`${process.env.REACT_APP_API_BASE_URL}/api/test-types`, {
        name: title.trim(), // backend modelde 'name' alanı varsa
        min_age: minAge || null,
        max_age: maxAge || null,
      });

      toast.success("Test türü başarıyla eklendi!");
      setTimeout(() => {
        nav("/test-types/table");
      }, 1000);
    } catch (err) {
      console.error("❌ Ekleme hatası:", err);
      toast.error("Ekleme sırasında bir hata oluştu");
    } finally {
      setLoading(false);
    }
  };

  return (
    <section className="p-4">
      <ToastContainer />
      <div className="card p-4">
        <h5 className="mb-3 fw-bold">Yeni Test Türü Ekle</h5>
        <form onSubmit={handleSubmit}>
          <div className="mb-3">
            <label className="form-label">Başlık</label>
            <input
              type="text"
              className="form-control"
              value={title}
              onChange={(e) => setTitle(e.target.value)}
              required
              disabled={loading}
            />
          </div>
          <div className="mb-3">
            <label className="form-label">Minimum Yaş</label>
            <input
              type="number"
              className="form-control"
              value={minAge}
              onChange={(e) => setMinAge(e.target.value)}
              disabled={loading}
            />
          </div>
          <div className="mb-3">
            <label className="form-label">Maksimum Yaş</label>
            <input
              type="number"
              className="form-control"
              value={maxAge}
              onChange={(e) => setMaxAge(e.target.value)}
              disabled={loading}
            />
          </div>
          <div className="d-flex justify-content-center">
            <button
              type="submit"
              className="btn btn-primary px-4"
              disabled={loading}
            >
              {loading ? "Kaydediliyor…" : "Kaydet"}
            </button>
          </div>
        </form>
      </div>
    </section>
  );
}
